import React from 'react'

import * as Sentry from '@sentry/react'

import {
  Auth0SpaProvider,
  AuthenticatedBrowserRouterProvider,
  bootstrapSpaApplication,
} from '@fortem-monorepo/react-spa'

import '@/index.css'
import { ApplicationErrorPage } from '@/pages/error'
import { router } from '@/router'

Sentry.init({
  dsn: 'https://d0f4af1d78ad654ba00ce1f43570215b@o4508886458892288.ingest.de.sentry.io/4508886461644880',
  environment: import.meta.env.MODE,
})

const domain = import.meta.env.VITE_AUTH0_DOMAIN
const clientId = import.meta.env.VITE_AUTH0_CLIENT_ID
const redirectUri = import.meta.env.VITE_BASE_URL
const audience = import.meta.env.VITE_AUTH0_AUDIENCE

const PortalErrorBoundary: React.FC<React.PropsWithChildren> = ({ children }) => (
  <Sentry.ErrorBoundary
    fallback={({ error, resetError }) => (
      <ApplicationErrorPage error={error} resetError={resetError} />
    )}
  >
    {children}
  </Sentry.ErrorBoundary>
)

if (domain && clientId && redirectUri) {
  bootstrapSpaApplication({
    ErrorBoundary: PortalErrorBoundary,
    children: (
      <Auth0SpaProvider
        domain={domain}
        clientId={clientId}
        redirectUri={redirectUri}
        audience={audience}
      >
        <AuthenticatedBrowserRouterProvider routes={router} />
      </Auth0SpaProvider>
    ),
  })
}
